/*=============================================== Hr ===============================================*/
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
/*==================== Imports ====================*/
import styled from "styled-components";
import Variables from "./Variables";
/*==================== Component ====================*/
var Hr = styled.hr(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    width: 100%;\n    height: 1px;\n    border: none;\n    background-color: ", ";\n    display: block;\n"], ["\n    width: 100%;\n    height: 1px;\n    border: none;\n    background-color: ", ";\n    display: block;\n"])), Variables.Colors.Gray200);
export default Hr;
var templateObject_1;
